// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LegalData_wrapper__Ov9b7","buttonWrapper":"LegalData_buttonWrapper__mz9FD","spinnerWrapper":"LegalData_spinnerWrapper__R5ZX4"};